
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[countryCode]",
      function () {
        return require("private-next-pages/[countryCode]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[countryCode]"])
      });
    }
  